/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { css } from 'styled-components'
import {
  dealInAnim,
  bankerDealOutAnim,
  playerDealOutAnim,
  scaleAnim,
  flipAnim,
  flickleAnim,
} from './animationKeyframes'

export const animations = (): any => {
  const dealIn = css`
    animation: ${dealInAnim} 0.4s forwards;
  `
  const bankerDealOut = css`
    animation: ${bankerDealOutAnim} 0.4s forwards;
  `
  const playerDealOut = css`
    animation: ${playerDealOutAnim} 0.4s forwards;
  `
  const scale = css`
    animation: ${scaleAnim} 0.6s forwards 0.3s;
  `
  const flip = css`
    animation: ${flipAnim} 0.4s forwards;
  `
  const flickle = css`
    animation: ${flickleAnim} 0.8s infinite;
  `
  return {
    dealIn,
    bankerDealOut,
    playerDealOut,
    scale,
    flip,
    flickle,
  }
}
